import React, { useContext, useState } from "react";
import MissionDelegateModal from "../Modal/MissionDelegateModal";
import UserInformationCard from "./UserInformationCard";
import { MissionContext } from "../contexts/MissionTasksContext";

const MissionDelegate = ({ canChangeMissionDelegate }) => {
  const missionContext = useContext(MissionContext);
  const [showModal, setShowModal] = useState(false);
  const initModal = () => setShowModal(!showModal);

  return (
    <>
      <UserInformationCard
        cardHeaderText="Mission Delegate"
        cardColor={"bg-light-4"}
        name={missionContext.missionData?.relationMissionDelegate?.name}
        email={missionContext.missionData?.relationMissionDelegate?.email}
        role={"Delegate"}
        status={"Registered"}
        change={initModal}
        buttonText={missionContext.missionData?.relationMissionDelegate === null ? "Assign" : "Change"}
        showButton={missionContext.is_archived?false: canChangeMissionDelegate()}
        infoText={"This country's delegate is not registered."}
      />
      <MissionDelegateModal
        isShow={showModal}
        initModal={initModal}
      />
    </>
  );
};

export default MissionDelegate;
